"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var marked = require("marked");
var escapeHtml = require("escape-html");
/**
 * Our CSS file
 */
require('./markdown.css');
/**
 * Renders markdown
 */
var MarkDown = /** @class */ (function (_super) {
    __extends(MarkDown, _super);
    function MarkDown(props) {
        return _super.call(this, props) || this;
    }
    MarkDown.prototype.render = function () {
        var rendered = toHtml(this.props.markdown);
        return (React.createElement("div", { dangerouslySetInnerHTML: { __html: rendered } }));
    };
    return MarkDown;
}(React.PureComponent));
exports.MarkDown = MarkDown;
/** Converts an html string to markdown */
function toHtml(markdown) {
    return ("<div class=\"alm-markdown-root\"> " + marked(escapeHtml(markdown))
        .replace(/a href=/g, "a target='_blank' href=")
        .trim()
        .replace(/\n/g, '<br/>') + "</div>");
}
exports.toHtml = toHtml;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/markdown/markdown.js
 ** module id = 405
 ** module chunks = 0
 **/